<mdb-navbar SideClass="navbar navbar-dark navbar-expand-xl indigo lighten-1 pt-0 pb-0" [containerInside]="false">
  <logo>
    <span class="white-text">{{ Localization.InterventionTeams | translate }}</span>
  </logo>
  <ul class="navbar-nav ml-auto"
      data-cy="job-boards-navigation">
    <li class="nav-item">
      <a class="nav-link waves-light" mdbRippleRadius routerLink="teams" routerLinkActive="bold amber-text">
        <span>{{ Localization.InterventionTeams | translate }}</span>
      </a>
    </li>
    <li class="nav-item nav-item-separator"><span class="nav-link">|</span></li>
    <li class="nav-item">
      <a class="nav-link waves-light" mdbRippleRadius queryParamsHandling="merge"
         routerLink="contacts" routerLinkActive="bold amber-text">
        <span>{{ Localization.Contacts | translate }}</span>
      </a>
    </li>
  </ul>
</mdb-navbar>
<router-outlet></router-outlet>
